webpackJsonp([482],{

/***/ 1682:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(2351),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/$t-is-not-defined-39.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] $t-is-not-defined-39.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7864f632", Component.options)
  } else {
    hotAPI.reload("data-v-7864f632", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2351:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("$t is not defined")]), _vm._v(" "), _c('p', [_vm._v("一般是两个原因：")]), _vm._v(" "), _c('h2', [_vm._v("cnpm 导致的问题")]), _vm._v(" "), _c('p', [_vm._v("如果是直接使用模板后并且使用 "), _c('code', [_vm._v("cnpm")]), _vm._v(" 报错，请升级到 "), _c('code', [_vm._v("vux-loader@1.0.58")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("该问题出现原因是 "), _c('code', [_vm._v("cnpm")]), _vm._v(" 安装后 "), _c('code', [_vm._v("node_modules")]), _vm._v(" 里的模块为快捷方式，而 "), _c('code', [_vm._v("vux-loader")]), _vm._v(" 之前版本没有考虑到这一特殊情况。")]), _vm._v(" "), _c('h2', [_vm._v("未正确配置动态 i18n")]), _vm._v(" "), _c('p', [_vm._v("demo例子使用"), _c('code', [_vm._v("$t")]), _vm._v("是因为demo启用了"), _c('code', [_vm._v("i18n")]), _vm._v("，如果你没有使用"), _c('code', [_vm._v("vuex-i18n")]), _vm._v("等相关"), _c('code', [_vm._v("i18n")]), _vm._v("插件，请不要在代码中使用"), _c('code', [_vm._v("$t")]), _vm._v("函数")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7864f632", module.exports)
  }
}

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1682);

/***/ }),

/***/ 867:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "$t is not defined | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 482.9be41796.js